import React, { ReactNode } from 'react';
import { featureFlagService } from 'store/feature-flag';
import useSelector from 'hooks/useSelector';
import { tokenSelector } from 'store/user/selectors';
import { FeatureFlagContext } from './index';

interface Props {
  children: ReactNode;
}

export const FeatureFlagProvider: React.FC<Props> = ({ children }) => {
  const accessToken = useSelector(tokenSelector);
  const { data: featureFlags = {}, isLoading } =
    featureFlagService.endpoints.getFeatureFlags.useQuery(undefined, {
      skip: !accessToken,
    });

  return (
    <FeatureFlagContext.Provider value={{ featureFlags, isLoading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
